import { ExpenseMetaType, ExpenseStatusType } from "@/types/db/expenses";

export type ExpenseForm = {
  expense_number?: string;
  description?: string;
  amount?: number;
  category?: string;
  client_id: string;
  project_id: string;
  shift_id?: string | null;
  user_id?: string; // optional crew member the expense is on behalf of
  status: ExpenseStatusType;
  meta_data?: ExpenseMetaType;
};

export type ExpensePayload = {
  expense: ExpenseForm;
};
